var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import { Box, Link, Tab, Table, TabList, TabPanel, TabPanels, Tabs, Tbody, Td, Tfoot, Th, Thead, Tr, } from '@chakra-ui/react';
import { ExternalLinkIcon } from '@chakra-ui/icons';
import { printLocation } from '../../shared/utility';
export var BusinessesView = function (_a) {
    var businesses = _a.businesses, randomBusiness = _a.randomBusiness;
    return (React.createElement(Box, null,
        React.createElement(Tabs, { variant: 'soft-rounded', colorScheme: 'telegram' },
            React.createElement(TabList, null,
                React.createElement(Tab, { role: 'group' }, "All Businesses"),
                React.createElement(Tab, { role: 'group' }, "Random Business")),
            React.createElement(TabPanels, null,
                React.createElement(TabPanel, null,
                    React.createElement(ShowBusinesses, __assign({}, businesses))),
                React.createElement(TabPanel, null,
                    React.createElement(ShowRandomBusiness, __assign({}, randomBusiness)))))));
};
var ShowBusinesses = function (_a) {
    var isLoading = _a.isLoading, error = _a.error, data = _a.data;
    return (React.createElement("div", null,
        isLoading && React.createElement("p", null, "Loading all businesses"),
        error && React.createElement("p", null, "Error in loading all businesses"),
        data && React.createElement(DisplayTable, { rows: data })));
};
var ShowRandomBusiness = function (_a) {
    var isLoading = _a.isLoading, error = _a.error, data = _a.data;
    return (React.createElement("div", null,
        isLoading && React.createElement("p", null, "Loading Random Business"),
        error && React.createElement("p", null, "Error in loading random business"),
        data && React.createElement(DisplayTable, { rows: [data], hideFooter: true })));
};
var DisplayTable = function (_a) {
    var rows = _a.rows, _b = _a.hideFooter, hideFooter = _b === void 0 ? false : _b;
    return (React.createElement(Table, { variant: 'simple' },
        React.createElement(Thead, null,
            React.createElement(Tr, null,
                React.createElement(Th, null, "Name"),
                React.createElement(Th, null, "Phone"),
                React.createElement(Th, null, "Location"),
                React.createElement(Th, null, "Categories"))),
        React.createElement(Tbody, { role: 'group' }, rows.map(function (row) { return (React.createElement(Tr, { key: row.url },
            React.createElement(Td, null,
                React.createElement(Link, { href: row.url, isExternal: true },
                    row.name,
                    " ",
                    React.createElement(ExternalLinkIcon, { mx: '2px' }))),
            React.createElement(Td, null, row.phone),
            React.createElement(Td, null, printLocation(row.location)),
            React.createElement(Td, null, row.categories.map(function (c) { return c.title; }).join(', ')))); })),
        !hideFooter && (React.createElement(Tfoot, null,
            React.createElement(Tr, null,
                React.createElement(Th, null, "Name"),
                React.createElement(Th, null, "Phone"),
                React.createElement(Th, null, "Location"),
                React.createElement(Th, null, "Categories"))))));
};
